import { BrowserModule,Title } from '@angular/platform-browser';


import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { MatSortModule } from '@angular/material/sort'

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MenuComponent } from './components/menu/menu.component';
import { StatisticsComponent } from './pages/statistics/statistics.component';
import { InstallationsListComponent } from './pages/installations/installations-list/installations-list.component';
import { CallsListComponent } from './pages/calls/calls-list/calls-list.component';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { InstallationComponent } from './pages/installation/installation/installation.component';
import { CompaniesListComponent } from './pages/companies-list/companies-list.component';
import { PeopleListComponent } from './pages/people-list/people-list.component';
import { PersonComponent } from './pages/person/person.component';
import { StockManagerComponent } from './pages/stock-manager/stock-manager.component';
import { HomeComponent } from './pages/home/home.component';
import { IncidentsListComponent } from './pages/incidents/incidents-list/incidents-list.component';
import { SeriesListComponent } from './pages/series-list/series-list.component';
import { ToolsComponent } from './pages/tools/tools.component';
import { WikiComponent } from './pages/wiki/wiki.component';
import { MessagesListComponent } from './pages/messages-list/messages-list.component';
import { FooterComponent } from './components/footer/footer.component';
import { InstallationsProjectsComponent } from './pages/installations/installations-projects/installations-projects.component';
import { InstallationsInstalledComponent } from './pages/installations/installations-installed/installations-installed.component';
import { InstallationsServiceComponent } from './pages/installations/installations-service/installations-service.component';
import { InstallationsStoppedComponent } from './pages/installations/installations-stopped/installations-stopped.component';
import { InstallationsUninstalledComponent } from './pages/installations/installations-uninstalled/installations-uninstalled.component';
import { InstallationsCustomComponent } from './pages/installations/installations-custom/installations-custom.component';
import { InstallationPropertiesComponent } from './pages/installation/installation-properties/installation-properties.component';
import { InstallationConnectionsComponent } from './pages/installation/installation-connections/installation-connections.component';
import { InstallationSalesComponent } from './pages/installation/installation-sales/installation-sales.component';
import { InstallationStatisticsComponent } from './pages/installation/installation-statistics/installation-statistics.component';
import { InstallationIncidentsComponent } from './pages/installation/installation-incidents/installation-incidents.component';
import { InstallationInterventionsComponent } from './pages/installation/installation-interventions/installation-interventions.component';
import { InstallationPhotosComponent } from './pages/installation/installation-photos/installation-photos.component';
import { InstallationMiscellaneousComponent } from './pages/installation/installation-miscellaneous/installation-miscellaneous.component';
import { InstallationIncidentsListComponent } from './pages/installation/installation-incidents-list/installation-incidents-list.component';
import { InstallationErrorReportsComponent } from './pages/installation/installation-error-reports/installation-error-reports.component';
import { CompanyComponent } from './pages/company/company.component';
import { MachineComponent } from './pages/machine/machine/machine.component';
import { MachinePropertiesComponent } from './pages/machine/machine-properties/machine-properties.component';
import { MachineEquipmentComponent } from './pages/machine/machine-equipment/machine-equipment.component';
import { MachineHistoricComponent } from './pages/machine/machine-historic/machine-historic.component';
import { CallComponent } from './pages/calls/call/call.component';
import { ChartsModule } from 'ng2-charts';
import { MessageComponent } from './pages/message/message.component';
import { LoginComponent } from './pages/login/login.component';
import { environment } from 'src/environments/environment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IncidentsComponent } from './pages/incidents/incidents/incidents.component';
import { IncidentsPannesComponent } from './pages/incidents-pannes/incidents-pannes.component';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { MatTabsModule  } from '@angular/material/tabs';
import { GmaoSpinnerComponent } from './components/gmao-spinner/gmao-spinner.component';
import {MatPaginatorModule} from '@angular/material/paginator';
import { SearchCallsComponent } from './components/extraction/search-calls/search-calls.component';
import { AdminComponent } from './pages/admin/admin.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatInputModule} from '@angular/material/input';
import { DateAdapter, MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import { SearchCallsContratSavComponent } from './components/search-calls-contrat-sav/search-calls-contrat-sav.component';
import { ChangelogsComponent } from './pages/changelogs/changelogs.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { PhotoComponent } from './components/photo/photo.component';
import { MatIconModule} from '@angular/material/icon';
import { DocumentComponent } from './components/document/document.component';
import { UsersComponent } from './components/users/users.component';
import { RatesComponent } from './components/rates/rates.component';
import { ExportButtonComponent } from './components/export-button/export-button.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { BreakdownStatsComponent } from './components/breakdown-stats/breakdown-stats.component';
import { PowerBiComponent } from './components/power-bi/power-bi.component';
import { EditUserComponent } from './components/users/edit-user/edit-user.component';
import { NgModule, LOCALE_ID } from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {MatDividerModule} from '@angular/material/divider';
import { MatAutocompleteModule } from "@angular/material/autocomplete";

import { Http401Interceptor } from './services/interceptors/Http401Interceptor';
import { DialogOverViewComponent } from './components/dialog-over-view/dialog-over-view.component';
import { InstallationMonthlyEvolutionComponent } from './pages/installation/installation-statistics/installation-monthly-evolution/installation-monthly-evolution.component';
import { InstallationHourlyDistributionComponent } from './pages/installation/installation-statistics/installation-hourly-distribution/installation-hourly-distribution.component';
import { InstallationWeeklyDistributionComponent } from './pages/installation/installation-statistics/installation-weekly-distribution/installation-weekly-distribution.component';
import { InstallationPaymentMethodComponent } from './pages/installation/installation-statistics/installation-payment-method/installation-payment-method.component';
import { ArbreManagementComponent } from './components/arbre-management/arbre-management.component';
import { EditArbreComponent } from './components/arbre-management/edit-arbre/edit-arbre.component';
import { ArbreComponentComponent } from './components/arbre-management/arbre-component/arbre-component.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { ElementChooserComponent } from './components/arbre-management/element-chooser/element-chooser/element-chooser.component';
import { CallsComponent } from './pages/calls/calls/calls.component';
import { NewCallComponent } from './pages/calls/new-call/new-call.component';
import { CallVerifsComponent } from './pages/calls/call-verifs/call-verifs.component';
import { CallDapInfosComponent } from './pages/calls/call-dap-infos/call-dap-infos.component';
import { CurrentVerifComponent } from './pages/calls/current-verif/current-verif.component';
import { GestionComponent } from './components/gestion/gestion.component';
import { DialogConfirmComponent } from './components/dialog-confirm/dialog-confirm/dialog-confirm.component';
import { EditGestionComponent } from './components/gestion/edit-gestion/edit-gestion/edit-gestion.component';
import { GestionAppelsSavComponent } from './components/gestion/gestion-component/gestion-appels-sav.component';
import { GestionActionsSavComponent } from './components/gestion/gestion-component/gestion-actions-sav/gestion-actions-sav.component';
import { GestionIntervenantsSavComponent } from './components/gestion/gestion-component/gestion-intervenants-sav/gestion-intervenants-sav.component';
import { SearchResultsComponent } from './pages/search-results/search-results.component';
import { RatesBreakdownComponent } from './components/rates/rates-breakdown/rates-breakdown.component';
import { ExtractionComponent } from './components/extraction/extraction.component';
import { SearchContractsComponent } from './components/extraction/search-contracts/search-contracts.component';
import { NbPanneCodesComponent } from './components/extraction/nb-panne-codes/nb-panne-codes.component';
import { ServiceInstallComponent } from './components/extraction/service-install/service-install.component';
import { ListInstallOwnerComponent } from './components/extraction/list-install-owner/list-install-owner.component';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HomeWarningComponent } from './pages/home/home-warning/home-warning.component';
import { MaterielComponent } from './pages/materiel/materiel.component';
import { MachineDatabaseComponent } from './pages/machine/machine-database/machine-database.component';
import { RatesAllComponent } from './components/rates/rates-view/rates-view.component';
import { CustomDateAdapter } from './custom-date-adapter';
import { CallRapportComponent } from './pages/calls/call-rapport/call-rapport.component';

import { registerLocaleData } from '@angular/common';
import localFr from '@angular/common/locales/fr';
import { GestionCommAreaComponent } from './components/gestion/gestion-component/gestion-comm-area/gestion-comm-area.component';
import { ExtractionMachinesInstalleesComponent } from './components/extraction/extraction-machines-installees/extraction-machines-installees.component';
import { InterventionAnalysisComponent } from './components/extraction/intervention-analysis/intervention-analysis.component';
import { BreakdownListComponent } from './components/extraction/breakdown-list/breakdown-list.component';
import { CheckAnalysisComponent } from './components/extraction/check-analysis/check-analysis.component';
import { ExtractionYearBreakdownsComponent } from './components/extraction/extraction-year-breakdowns/extraction-year-breakdowns.component';
import { ExtractionBreakdownsSolverComponent } from './components/extraction/extraction-breakdowns-solver/extraction-breakdowns-solver.component'

export const isMock = environment.mock;

@NgModule({
  declarations: [
    AppComponent,
    MenuComponent,
    StatisticsComponent,
    InstallationsListComponent,
    CallsListComponent,
    SearchBarComponent,
    InstallationComponent,
    CompaniesListComponent,
    PeopleListComponent,
    PersonComponent,
    StockManagerComponent,
    HomeComponent,
    IncidentsListComponent,
    SeriesListComponent,
    ToolsComponent,
    WikiComponent,
    MessagesListComponent,
    FooterComponent,
    InstallationsProjectsComponent,
    InstallationsInstalledComponent,
    InstallationsServiceComponent,
    InstallationsStoppedComponent,
    InstallationsUninstalledComponent,
    InstallationsCustomComponent,
    InstallationPropertiesComponent,
    InstallationConnectionsComponent,
    InstallationSalesComponent,
    InstallationStatisticsComponent,
    InstallationIncidentsComponent,
    InstallationInterventionsComponent,
    InstallationPhotosComponent,
    InstallationMiscellaneousComponent,
    InstallationIncidentsListComponent,
    InstallationErrorReportsComponent,
    CompanyComponent,
    MachineComponent,
    MachinePropertiesComponent,
    MachineEquipmentComponent,
    MachineHistoricComponent,
    CallComponent,
    MessageComponent,
    LoginComponent,
    IncidentsComponent,
    IncidentsPannesComponent,
    GmaoSpinnerComponent,
    SearchCallsComponent,
    AdminComponent,
    SearchCallsContratSavComponent,
    ChangelogsComponent,
    PhotoComponent,
    DocumentComponent,
    UsersComponent,
    RatesComponent,
    ExportButtonComponent,
    BreakdownStatsComponent,
    PowerBiComponent,
    EditUserComponent,
    DialogOverViewComponent,
    InstallationMonthlyEvolutionComponent,
    InstallationHourlyDistributionComponent,
    InstallationWeeklyDistributionComponent,
    InstallationPaymentMethodComponent,
    ArbreManagementComponent,
    EditArbreComponent,
    ArbreComponentComponent,
    ElementChooserComponent,
    CallsComponent,
    NewCallComponent,
    CallVerifsComponent,
    CallDapInfosComponent,
    CurrentVerifComponent,
    GestionComponent,
    DialogConfirmComponent,
    EditGestionComponent,
    GestionAppelsSavComponent,
    GestionActionsSavComponent,
    GestionIntervenantsSavComponent,
    SearchResultsComponent,
    RatesBreakdownComponent,
    ExtractionComponent,
    SearchContractsComponent,
    NbPanneCodesComponent,
    ServiceInstallComponent,
    ListInstallOwnerComponent,
    HomeWarningComponent,
    MaterielComponent,
    MachineDatabaseComponent,
    RatesAllComponent,
    CallRapportComponent,
    GestionCommAreaComponent,
    ExtractionMachinesInstalleesComponent,
    InterventionAnalysisComponent,
    BreakdownListComponent,
    CheckAnalysisComponent,
    ExtractionYearBreakdownsComponent,
    ExtractionBreakdownsSolverComponent,
  ],
  
  imports: [
    BrowserModule,
    AppRoutingModule,
    ChartsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NoopAnimationsModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    BrowserAnimationsModule,
    MatPaginatorModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    MatSelectModule,
    NgxPaginationModule,
    MatIconModule,
    MatFormFieldModule,
    MatTableModule,
    MatDialogModule,
    DragDropModule,
    MatDividerModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatSortModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
    }),
  ],
  providers: [
    Title,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Http401Interceptor,
      multi: true
    },

    { 
      provide: MAT_DATE_LOCALE, 
      useValue: 'fr-FR' 
    },
    { 
      provide: DateAdapter, 
      useClass: CustomDateAdapter
    },
    { provide: LOCALE_ID, useValue: 'fr-FR'},
  ],
  bootstrap: [AppComponent],
  
})
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http,"./assets/i18n/",".json");
}